<template>
  <div style="width:100%;margin: 20px;">
    <el-tabs
      type="border-card"
      @tab-click="handleClick"
    >
      <el-tab-pane label="机构信息">
        <partyGroup />
      </el-tab-pane>
      <el-tab-pane
        v-if="jsShow"
        label="江苏上报机构信息维护"
      >
        <partyGroupRoportJs v-if="isShowJsBranchMsg" />
      </el-tab-pane>
      <!-- <el-tab-pane label="广东上报机构信息维护" v-if="gdShow">
        <partyGroupRoportGd v-if="isShowGdBranchMsg" />
      </el-tab-pane> -->
      <el-tab-pane
        v-if="gdShow"
        label="广东上报机构信息维护"
      >
        <partyGroupRoportGd v-if="isShowGdBranchMsg" />
      </el-tab-pane>
      <!-- <el-tab-pane label="计价体系" v-if="ctmsShow">
        <PriceSystem v-if="isPriceSystemShow"/>
      </el-tab-pane>-->
    </el-tabs>
  </div>
</template>
<script>
// import { isURL, isEmail, isCellphone } from '@/utils/validate4Form'
import partyGroup from "./components/partyGroup";
import partyGroupRoportJs from "./components/partrGroup_js_report";
import partyGroupRoportGd from "./components/partyGroup_gd_report";
// import PriceSystem from "@/views/basicInfo/priceSystem/priceSystem";
import { getRole } from "@/utils/getRole";
import { reportType, reportTypeGuangdong } from "@/utils/reportType";

export default {
  name: "SysSetting",
  components: {
    // ImgUpload
    partyGroup,
    // PriceSystem,
    partyGroupRoportJs,
    partyGroupRoportGd
  },
  data() {
    return {
      isPriceSystemShow: false,
      ctmsShow: false,
      jsShow: false,
      gdShow: false,
      isShowJsBranchMsg: false,
      isShowGdBranchMsg: false
    };
  },
  created() {
    this.ctmsShow = getRole();
    this.jsShow = reportType();
    this.gdShow = reportTypeGuangdong();
  },
  methods: {
    handleClick(tab, event) {
      this.isPriceSystemShow = true;
      if (this.jsShow) {
        this.isShowJsBranchMsg = true;
      }
      if (this.gdShow) {
        this.isShowGdBranchMsg = true;
      }
    }
  }
};
</script>
